import { createContext } from 'react';
export function createEmptyContext() {
    return createContext({});
}
